import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// eslint-disable-next-line css-modules/no-unused-class
import s from './NavegadorIncompatible.css';
import browserSadImg from '../../../../public/images/browser_sad.png';
import browserChromeImg from '../../../../public/images/chrome.png';

class NavegadorIncompatible extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <picture>
          <img alt="" className={s.browserSad} src={browserSadImg} />
        </picture>
        <p>
          <span className={s.title}>
            Tu navegador no es compatible con E-Consulta
          </span>
        </p>
        <span className={s.message}>
          {this.props.children}
        </span>
        <p className={s.browser}>
          <picture>
            <img alt="" src={browserChromeImg} />
          </picture>
          <br />
          <a className="s.download" href="https://www.google.com/chrome">
            Descargar Google Chrome
          </a>
        </p>
      </div>
    );
  }
}

NavegadorIncompatible.propTypes = {
  children: PropTypes.node.isRequired,
};

export default connect(null, null)(withStyles(s)(NavegadorIncompatible));



// WEBPACK FOOTER //
// ./src/components/Telemedicina/NavegadorIncompatible/NavegadorIncompatible.js